module.exports = __webpack_public_path__ + "assets/svg/Icons/48/newsfeed-blue-4bb547.svg";